import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CarvanaButton } from '@carvana/purchase-styles';

class FileSelector extends Component {
  static propTypes = {
    handleSelectedFile: PropTypes.func.isRequired,
    buttonClicked: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
      .isRequired,
    acceptableFiles: PropTypes.string,
    ghost: PropTypes.bool,
    buttonStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    uppercase: PropTypes.bool,
    multipleFiles: PropTypes.bool,
    disableButton: PropTypes.bool
  };

  static defaultProps = {
    acceptableFiles: null,
    buttonClicked: () => {},
    buttonStyles: null,
    ghost: false,
    uppercase: false,
    multipleFiles: false,
    disableButton: false
  };

  onChangeHandler = e => {
    e.preventDefault();
    const { handleSelectedFile } = this.props;
    const { files } = e.currentTarget;

    if (files && files.length > 0) {
      handleSelectedFile(files);
    }

    e.currentTarget.value = null;
  };

  onButtonClick = () => {
    const { buttonClicked } = this.props;
    buttonClicked();
    this.fileInput.click();
  };

  render() {
    const {
      children,
      acceptableFiles,
      buttonStyles,
      ghost,
      uppercase,
      multipleFiles,
      disableButton
    } = this.props;
    return (
      <Fragment>
        <CarvanaButton
          buttonStyles={buttonStyles}
          onClick={this.onButtonClick}
          ghost={ghost}
          uppercase={uppercase}
          disabled={disableButton}
        >
          {children}
        </CarvanaButton>
        <input
          type="file"
          id="file"
          style={{ display: 'none' }}
          accept={acceptableFiles}
          multiple={multipleFiles}
          ref={ref => {
            this.fileInput = ref;
          }}
          onChange={this.onChangeHandler}
        />
      </Fragment>
    );
  }
}

export default FileSelector;
